import createRoutine from '@/utils/createRoutine'

export const swoopAssistantRoutine = createRoutine('swoopAssistantRoutine')

export const swoopAssistantGetters = {
  SWOOP_ASSISTANT: 'SWOOP_ASSISTANT'
}
export const SWOOP_ASSISTANT_CLEANUP = 'SWOOP_ASSISTANT_CLEANUP'
